import React from 'react';

import Loader from '../Controls/Loader/Loader';

import sfServerIcon from '../common/Images/sf_server.png';

import classes from './NodeCard.module.css';
import { FEATURE_FLAGS_NAMES, NODE_TYPE } from '@silverfort-nodelibs/common/utils/consts';
import useFeature from '../SystemSettings/hooks/featureFlags/useFeature';
import { SYSTEM_MODES } from '@silverfort-nodelibs/common/utils/system-mode-config';

const NodeCard = (props) => {
    const onChangeHandler = () => {
        if (!props.canUpdate) {
            return;
        }

        props.nodeChecked(props.id, props.type);
    };

    const nodeCardClasses = [classes.nodeCard];
    if (props.canUpdate) {
        nodeCardClasses.push(classes.clickable);
    }
    if (props.disableDisconnected && !props.connected) {
        nodeCardClasses.push(classes.disconnected);
    }

    const connectivityClasses = ['fa fa-wifi', classes.connectivity];
    const systemMode = useFeature(FEATURE_FLAGS_NAMES.SystemMode);
    const hideConnectivity =
        (props.type === NODE_TYPE.WALL || props.type === NODE_TYPE.ARYA) && systemMode !== SYSTEM_MODES.ON_PREM;
    if (props.connected) {
        connectivityClasses.push(classes.connected);
    }

    const showLoader = props.checkingConnectivity || !props.connectivityReason;
    return (
        <div className={nodeCardClasses.join(' ')} onClick={onChangeHandler}>
            <div className={classes.nodeCardHeader}>
                {!props.hideCheckbox && (
                    <div className={['sfcheckbox', classes.checkboxContainer].join(' ')}>
                        <input
                            id={props.id}
                            type="checkbox"
                            disabled={!props.canUpdate}
                            checked={props.nodeCheckValue}
                            onChange={onChangeHandler}
                        />
                        <label className="checkboxLabel" htmlFor={props.id}></label>
                    </div>
                )}

                <img className={classes.nodeCardHeaderImage} src={sfServerIcon} alt="" />
                <div className={classes.nodeCardHeaderDescription}>
                    <div title={props.headerDescription}>{props.headerDescription}</div>
                    <div className={classes.nodeAZ} title={props.headerAZ}>
                        {Array.isArray(props.headerAZ) ? props.headerAZ.join(', ') : props.headerAZ}
                    </div>
                    {props.domain && <div className={classes.nodeAZ}>{props.domain}</div>}
                </div>
            </div>
            <div className={classes.nodeCardFooter}>
                {showLoader && (
                    <div title="Checking connectivity">
                        <Loader extraStyles={{ width: '25px', height: '25px', marginRight: '12px' }} />
                    </div>
                )}
                {!showLoader && !hideConnectivity && (
                    <i title={props.connectivityReason} className={connectivityClasses.join(' ')}></i>
                )}
                <div className={classes.nodeCardFooterHeader}>{props.footerHeader}</div>
            </div>
        </div>
    );
};

export default NodeCard;
